module.exports = __webpack_public_path__ + "static/img/pic_phone_3.279aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_3.png
// module id = pXAA
// module chunks = 1